// extracted by css-extract-rspack-plugin
export default {"root":"FooterWrapperV8_root__xKKLG"};